exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("assets/images/send_to_device/bg.jpg"));

// Module
exports.push([module.id, ".S2DLayout-8dfd740c{background:linear-gradient(to bottom, rgba(0,0,0,0.2), rgba(0,0,0,0.2)),url(" + ___CSS_LOADER_URL___0___ + ") center/cover;height:calc(100vh - 60px);display:flex;align-items:center;justify-content:center}.S2DLayout-8dfd740c p{margin-bottom:15px !important}.Modal-ccb21158{width:80vw;min-height:550px;max-width:700px}.modalContent-2b185a57{position:relative}.Footer-bc8ccd7f{display:flex;justify-content:space-between}.Footer-bc8ccd7f .stepText-a022ba96{font-size:14px;font-style:italic;margin-bottom:15px}.Footer-bc8ccd7f .prev-7af77eca{margin-right:20px}\n", ""]);

// Exports
exports.locals = {
	"S2DLayout": "S2DLayout-8dfd740c",
	"Modal": "Modal-ccb21158",
	"modalContent": "modalContent-2b185a57",
	"Footer": "Footer-bc8ccd7f",
	"stepText": "stepText-a022ba96",
	"prev": "prev-7af77eca"
};